import React, { Fragment } from 'react';
import { ListItemLink } from '@/se/components/collection/mobile/ListItem';
import { Column, Row, Value, TwoItemSection } from '@/se/components/collection/mobile/shared';

const ScreenMobileListItem = ({
  history,
  location,
  columns,
  item,
  context,
  index: i,
  showUrlProvider,
  idProvider,
  onClick,
}) => {
  if (item.separator) {
    return null;
  }
  const codeColumn = columns.find(_ => _.key === 'code');
  const connectionColumn = columns.find(_ => _.key === 'connection');
  const configurationDescriptionColumn = columns.find(_ => _.key === 'configuration.description');
  const dataConnectionColumn = columns.find(_ => _.key === 'data.connection');
  const removeScreenColumn = columns.find(_ => _.key === 'removeScreen');

  return (
    <Fragment>
      <ListItemLink onClick={onClick}>
        <TwoItemSection style={{ marginBottom: '0.75rem' }}>
          <Column>
            <Value trimText>{codeColumn.lens(item, context)}</Value>
          </Column>
          <Column>
            <connectionColumn.Component data={connectionColumn.lens(item, context)} />
          </Column>
        </TwoItemSection>
        <Row style={{ marginBottom: '0.75rem' }}>
          <Value trimText>{configurationDescriptionColumn.lens(item, context)}</Value>
        </Row>
        <TwoItemSection>
          <Column>
            <dataConnectionColumn.Component data={dataConnectionColumn.lens(item, context)} />
          </Column>
          <Column>
            <removeScreenColumn.Component data={removeScreenColumn.lens(item, context)} />
          </Column>
        </TwoItemSection>
      </ListItemLink>
    </Fragment>
  );
};

export default ScreenMobileListItem;
